module.exports = __webpack_public_path__ + "static/media/ic_get_money.58eac0b3.svg";